export class CognitoUserGroups {
    public static readonly App: string = "App";
    public static readonly Bilhetagem: string = "Bilhetagem";
    public static readonly CaixaTem: string = "CaixaTem";
    public static readonly Loja: string = "Loja";
    public static readonly Tiqueteira: string = "Tiqueteira";
    public static readonly PrestacaoContas: string = "PrestacaoContas";
    public static readonly Administrativo: string = "Administrativo";
}
